function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M0 13.4136H12.859V0.554688H0V13.4136ZM2.33799 2.89268H10.521V11.0757H2.33799V2.89268ZM4.67598 5.23067H8.18297V8.73766H4.67598V5.23067ZM28.0559 0.554688H15.1969V13.4136H28.0559V0.554688ZM25.7179 11.0757H17.5349V2.89268H25.7179V11.0757ZM23.3799 8.73766H19.8729V5.23067H23.3799V8.73766ZM0 28.6106H12.859V15.7516H0V28.6106ZM2.33799 18.0896H10.521V26.2726H2.33799V18.0896ZM4.67598 20.4276H8.18297V23.9346H4.67598V20.4276ZM19.8729 15.7516V20.4276H15.1969V15.7516H19.8729ZM19.8729 20.4276H23.3799V23.9346H19.8729V20.4276ZM15.1969 23.9346H19.8729V28.6106H15.1969V23.9346ZM28.0559 15.7516V20.4276H23.3799V15.7516H28.0559Z",
  fill: "#4592FB"
});

function SvgPaymentlocal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentlocal);
export default __webpack_public_path__ + "static/media/paymentlocal.29270f66.svg";
export { ForwardRef as ReactComponent };